<!-- Le formulaire apparaît une fois son contexte chargé ; une erreur initiale reste réessayable. -->
@if (chargementInitial()) {
  <p class="information" role="status">Chargement de la centrale et du ticket…</p>
  <button class="fermer" type="button" (click)="fermer()">Annuler</button>
} @else if (erreurInitiale()) {
  <p class="information" role="alert">{{ erreurInitiale() }}</p>
  <button class="fermer" type="button" (click)="charger()">Réessayer</button>
  <button class="fermer" type="button" (click)="fermer()">Annuler</button>
} @else {
  <div #formulaire>
    <app-intervention-formulaire
      [nature]="data.nature"
      [transformation]="data.transformation ?? false"
      [droits]="droits()"
      [utilisateur]="auth.tokenInfoSignal()"
      [options]="optionsAutorisees()"
      [contexte]="contexte()"
      [edition]="edition()"
      [chargement]="chargementTickets()"
      [erreurChargement]="erreurTickets()"
      [autorisationServeur]="autorisationServeur()"
      [photosExistantes]="photosExistantes()"
      [enregistrer]="enregistrer"
      (enregistre)="terminer()"
      (installationChange)="chargerTickets($event)"
      (recharger)="chargerTickets(installationSelectionnee())"
      (annuler)="fermer()"
    />
  </div>
}
